import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  get () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}role`, AUTH_HEADERS())
  }
}
